<template>
  <div>
    <v-bottom-navigation value="Favorites" color="deep-purple accent-4">
      <v-btn value="Recents">
        <span>Recents</span>
        <v-icon>mdi-history</v-icon>
      </v-btn>

      <v-btn value="Favorites">
        <span>Favorites</span>
        <v-icon>mdi-heart</v-icon>
      </v-btn>

      <v-btn value="Nearby">
        <span>Nearby</span>
        <v-icon>mdi-map-marker</v-icon>
      </v-btn>
    </v-bottom-navigation>
  </div>
</template>

<script>
export default {
  data() {
    return {
      activeBtn: true
    };
  }
};
</script>

<style></style>
